import api from '@/services/api';

class Sync {
  /**
   * Sube una recogida (cabecera + líneas) al server limpio.
   * payload: { fecha, nombre, lineas: [{ explotacion_codigo, litros, temperatura, acidez, inhibidores, muestra, tipo_leche, hora }] }
   * Respuesta: { ok, recogida_id, lineas_creadas, explotaciones_no_encontradas }
   */
  async uploadRecogida(payload) {
    return api.post('recogidas', payload)
  }

  /**
   * Sube una OtraRecogida (movimiento desde otro operador/centro).
   * payload con keys snake_case (ver docs/API-MOVIL.md del server).
   * Respuesta: { ok, id }
   */
  async uploadOtraRecogida(payload) {
    return api.post('otras-recogidas', payload)
  }

  /**
   * Sube una Descarga (vaciado de la cisterna en industria).
   * Requiere recogida_cabecera_id (cabecera de la ruta en curso).
   * payload con keys snake_case (ver docs/API-MOVIL.md).
   * Respuesta: { ok, id, recogida_cabecera_id }
   */
  async uploadDescarga(payload) {
    return api.post('descargas', payload)
  }

  /**
   * Sube un Traspaso entre depósitos de la propia cisterna.
   * Requiere recogida_cabecera_id, deposito_origen, deposito_destino, litros.
   * Respuesta: { ok, id }
   */
  async uploadTraspaso(payload) {
    return api.post('traspasos', payload)
  }

  async download() {
    const endpoints = ['rutas', 'explotaciones', 'letraqs', 'centrorecogidas', 'incidencias', 'destinos', 'industrias', 'conductors', 'nifs', 'vehiculos']
    const promises = Promise.all(endpoints.map((endpoint) => {
      return api.get(endpoint)
    }));

    return promises.then((data) => {
      const result = {}
      data.forEach((response, index) => {
        result[endpoints[index]] = response.data.data
      })
      return result
    })
      .catch((error) => {
        if (error.response.status === 429) {
          throw new Error('Demasiadas peticiones, espere unos minutos y vuelva a intentarlo.')
        }
        throw error;
      })
  }
}

export default new Sync();
